export const IMAGE_BUTTON_VARIANTS = {
    APP_STORE: "app-store",
    PLAY_STORE: "play-store",
} as const;
